<div class="p-3">
  <div class="mb-2">
    <ng-icon class="text-text-interactive" name="stethoscope" size="20"></ng-icon>
    <h2 class="text-lg font-bold">
      Iniciar teste gratuito por 14 dias
    </h2>
  </div>

  <p class="text-sm mb-1">
    Sua corretora terá acesso ao módulo saúde por 14 dias, sem custo.
  </p>

  <p class="text-sm">
    A contratação não é automática e você poderá decidir ao final do período.
  </p>

  <div class="flex justify-end gap-3 mt-6">
    <button mat-button (click)="cancelar()" class="my-btn my-btn--outlined"
      [ngClass]="{'my-btn--disabled': carregando}">
      Cancelar
    </button>

    <button mat-button (click)="iniciarTeste()" class="my-btn my-btn--filled"
      [ngClass]="{'my-btn--disabled animate-in animate-pulse': carregando  }">
      {{ carregando ? 'Aguarde...' : 'Iniciar teste' }}
    </button>
  </div>
</div>
